// src/components/ShortcutsDialog.jsx
// The list of keyboard shortcuts (3.47.0), opened with ? or from Preferences.
// Same look as the other small pop-ups (My profile's dialog styles).
import { useEffect, useRef } from 'react';
import { dialogStyles as S } from './ProfileDialog';
import { SHORTCUTS } from '../hooks/useShortcuts';
import Emo from './Emo';

export default function ShortcutsDialog({ onClose, onPreferences }) {
  const closeRef = useRef(null);
  // 3.57.5: once, when the window opens (the parent passes a new onClose on
  // every render; re-running moved the cursor to ✕ on every refresh, e.g. a
  // fax pop-up, and the next Space/Enter closed the window)
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  useEffect(() => {
    closeRef.current?.focus();
    const onKey = e => { if (e.key === 'Escape') { e.preventDefault(); onCloseRef.current(); } };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div style={S.overlay} onMouseDown={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ ...S.modal, maxWidth: 440 }} role="dialog" aria-modal="true" aria-labelledby="shortcuts-title">
        <div style={S.header} className="dlg-head">
          <div style={{ minWidth: 0 }}>
            <h2 id="shortcuts-title" style={S.title}><Emo e="⌨️" /> Keyboard shortcuts</h2>
            <div style={S.sub}>Press a key anywhere in the portal, except while typing in a box</div>
          </div>
          <button ref={closeRef} onClick={onClose} style={S.closeBtn} aria-label="Close">✕</button>
        </div>
        <div style={S.body}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <tbody>
              {SHORTCUTS.map(s => (
                <tr key={s.what} style={{ borderBottom: '1px solid var(--c-eceff1)' }}>
                  <td style={{ padding: '8px 0', whiteSpace: 'nowrap', width: 1 }}>
                    {s.keys.map((k, i) => (
                      <span key={k}>{i > 0 && <span style={{ color: 'var(--t-546e7a)', fontSize: 12, margin: '0 6px' }}>then</span>}
                        <kbd style={K}>{k}</kbd></span>
                    ))}
                  </td>
                  <td style={{ padding: '8px 0 8px 16px', color: 'var(--t-263238)' }}>{s.what}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p style={{ ...S.note, marginTop: 14 }}>
            Don't want them? Turn them off in{' '}
            <button type="button" onClick={onPreferences} style={{ background: 'none', border: 'none', padding: 0, font: 'inherit', color: 'var(--t-00897b)', textDecoration: 'underline', cursor: 'pointer' }}>Preferences</button>.
          </p>
        </div>
      </div>
    </div>
  );
}

const K = {
  display: 'inline-block', minWidth: 26, padding: '3px 8px', borderRadius: 7, textAlign: 'center',
  fontFamily: 'inherit', fontSize: 13, fontWeight: 800, color: 'var(--t-00695c)',
  background: 'var(--c-f5faf9)', border: '1.5px solid var(--c-b2dfdb)', boxShadow: '0 2px 0 var(--c-b2dfdb)',
};
